// Pulsar + proposal + check-in status badges (standing-agent-ui "Status
// vocabulary and rendering"; DESIGN.md status pills). Follows
// PlaybookStatusBadge's shape; the vocabulary lives in ./statusMeta.

import { SvgIcon } from '@progress/kendo-react-common';
import { clockIcon } from '@progress/kendo-svg-icons';
import type { CheckInEntryStatus, ProposalStatus, StandingStatus } from '@shared/api-types';
import { checkInStatusMeta, PROPOSAL_STATUS, STANDING_STATUS, type BadgeMeta } from './statusMeta';

function Pill({ meta }: { meta: BadgeMeta }) {
  return (
    <span
      className="pulsar-pill"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        borderRadius: 'var(--radius-sm)',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.5,
        color: meta.color,
        background: `color-mix(in srgb, ${meta.color} 12%, transparent)`,
        whiteSpace: 'nowrap',
      }}
    >
      <SvgIcon icon={meta.icon} size="xsmall" aria-hidden style={{ flex: '0 0 auto' }} />
      {meta.label}
    </span>
  );
}

export function StandingStatusBadge({ status }: { status: StandingStatus }) {
  return <Pill meta={STANDING_STATUS[status] ?? { label: status, icon: clockIcon, color: 'var(--fg-muted)' }} />;
}

export function CheckInStatusBadge({ status }: { status: CheckInEntryStatus | null | undefined }) {
  return <Pill meta={checkInStatusMeta(status)} />;
}

export function ProposalStatusBadge({ status }: { status: ProposalStatus }) {
  return <Pill meta={PROPOSAL_STATUS[status] ?? { label: status, icon: clockIcon, color: 'var(--fg-muted)' }} />;
}
